import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var marginCalculator = {
    calculateMargin: config.jmw + config.equity + "span/calculate",
    searchSymbol: config.jmw + config.jmw_content + "search/derivatives/v1",
    getDerivative: config.jmw + config.jmw_content + "search/derivative/details/v1",
    getStrikePrice: config.jmw + config.jmw_content + "search/derivative/strikeprice",
};
export default marginCalculator;
